export default {
  en: {
    widgetUnavailableTitle: 'Widget unavailable',
    widgetUnavailableText: 'This plugin is not installed or is currently unavailable.',
    pluginsInfoTitle: 'To use plugins, your organization must have at least one Plugin registry and a connected Plugin manager.',
    pluginsInfoDescription: 'Add a registry and accept a Plugin Manager request to get started.',
    pluginName: 'Plugin Name',
    pluginSettings: 'Plugin Settings',
    browsePlugins: 'Browse Plugins',
    navOrdering: 'Sidebar ordering',
    pluginRegistries: 'Plugin registries',
    pluginRegistriesDescription: 'Configure external registries where Cycloid retrieves available plugins. When a registry is added, its plugins can be discovered and used across your organization.',
    noPluginRegistriesAdded: 'No plugin registries added',
    addPluginRegistryDescription: 'Add a registry to start using plugins',
    readMoreAboutPluginRegistries: 'Read more about Plugin registries',
    connectRegistry: 'Connect registry',
    registry: 'Registry',
    access: 'Access',
    status: 'Status',
    connectionErrorTitle: 'Connection failed',
    connectionErrorDescription: 'Unable to connect to the registry. Please check the URL and try again.',
    pluginManager: 'Plugin manager',
    pluginManagerDescription: 'The Plugin manager deploys plugins, orchestrates their containers, and acts as the communication proxy between Cycloid, the plugin, and external requests.',
    readMoreAboutPluginManager: 'Read more about Plugin manager',
    noPluginManagerConnected: 'No plugin manager connected',
    noPluginManagerConnectedDescription: 'The Plugin Manager must first send a connection request to your organization. Once the request appears here, you can accept or deny it.',
    readMoreAboutConnectingPluginManager: 'Read more about connecting a Plugin Manager',
    seeHowToEmitRequest: 'See how to emit a request',
    pluginManagerRequestTitle: 'A Plugin Manager has requested to connect to your organization.',
    pluginManagerRequestDescription: 'Accepting this request will set it as your plugin manager and enable plugin installation.',
    name: 'Name',
    url: 'URL',
    requestedAt: 'Requested at',
    accept: 'Accept',
    deny: 'Deny',
    offline: 'Offline',
    connected: 'Connected',
    readOnly: 'Read-only',
    readWrite: 'Read & Write',
    needHelp: 'Need help?',
    connectPluginRegistry: 'Connect plugin registry',
    registryName: 'Registry name',
    registryNameHint: 'A unique name for this registry',
    registryURL: 'Registry URL',
    registryURLHint: 'The URL where the registry is hosted',
    rename: 'Rename',
    disconnect: 'Disconnect',
    createPluginTitle: 'Create a new plugin',
    createPluginDescription: 'Start by giving your plugin a name. After that, you can publish its first version by referencing a Docker image from your registry.',
    pluginNameHint: 'The human readable name for your plugin.',
    pluginRegistryHint: 'The plugin registry where to register this plugin.',
    renamePluginRegistry: 'Rename plugin registry',
    renameRegistry: 'Rename registry',
    disconnectPluginRegistry: 'Disconnect plugin registry',
    disconnectRegistry: 'Disconnect registry',
    disconnectRegistryWarning: 'Disconnecting this plugin registry will remove its plugins from view in this organisation. Plugins that are already installed will remain usable but will be marked as orphaned (missing source).',
    disconnectRegistryNote: 'The registry itself and its plugins are not deleted and can be reconnected later.',
    failedToCreatePlugin: 'Failed to create plugin',
    failedToCreatePluginRegistry: 'Failed to connect plugin registry',
    pluginCreatedSuccessfully: 'Plugin created successfully',
    failedToRenamePluginRegistry: 'Failed to rename plugin registry',
    failedToDisconnectPluginRegistry: 'Failed to disconnect plugin registry',
    failedToUpdatePluginManager: 'Failed to update plugin manager',
    pluginManagerUpdatedSuccessfully: 'Plugin manager updated successfully',
    disconnectPluginManager: 'Disconnect plugin manager',
    disconnectManager: 'Disconnect manager',
    disconnectPluginManagerWarning: 'Disconnecting your plugin manager will remove all plugins currently installed through it. This action cannot be undone.',
    failedToDisconnectPluginManager: 'Failed to disconnect plugin manager',
    pluginManagerDisconnectedSuccessfully: 'Plugin manager disconnected successfully',
    sharing: {
      title: 'Plugin Sharing',
      visibilityLabel: 'Visibility',
      local: 'Local',
      localHint: 'Only this organization can see this plugin',
      shared: 'Shared',
      sharedHint: 'Share this plugin with child organizations',
      modeLabel: 'Sharing mode',
      modeAllChildren: 'Share with all child organizations',
      modeInclude: 'Share with specific organizations',
      modeExclude: 'Share with all except...',
      inheritedFrom: 'Shared from {org}',
      readOnly: 'Read-only (shared from {org})',
      organizations: 'Organizations',
      selectOrganizations: 'Select organizations...',
      save: 'Save',
      saveSuccess: 'Sharing configuration updated',
    },
  },
  fr: {
    widgetUnavailableTitle: 'Widget indisponible',
    widgetUnavailableText: 'Ce plugin n\'est pas installé ou est actuellement indisponible.',
    pluginsInfoTitle: 'Pour utiliser des plugins, votre organisation doit avoir au moins un registre de plugins et un gestionnaire de plugins connecté.',
    pluginsInfoDescription: 'Ajoutez un registre et acceptez une demande de connexion de gestionnaire de plugins pour commencer.',
    pluginName: 'Nom de plugin',
    pluginSettings: 'Paramètres de plugin',
    browsePlugins: 'Parcourir les plugins',
    navOrdering: 'Ordre de la barre latérale',
    pluginRegistries: 'Registres de plugins',
    pluginRegistriesDescription: 'Configurez des registres externes où Cycloid récupère les plugins disponibles. Lorsqu\'un registre est ajouté, ses plugins peuvent être découverts et utilisés dans toute votre organisation.',
    noPluginRegistriesAdded: 'Aucun registre de plugins ajouté',
    addPluginRegistryDescription: 'Ajoutez un registre pour commencer à utiliser des plugins',
    readMoreAboutPluginRegistries: 'En savoir plus sur les registres de plugins',
    connectRegistry: 'Connecter un registre',
    registry: 'Registre',
    access: 'Accès',
    status: 'Statut',
    connectionErrorTitle: 'Échec de la connexion',
    connectionErrorDescription: 'Impossible de se connecter au registre. Veuillez vérifier l\'URL et réessayer.',
    pluginManager: 'Gestionnaire de plugins',
    pluginManagerDescription: 'Le gestionnaire de plugins déploie les plugins, orchestrant leurs conteneurs et agissant comme proxy de communication entre Cycloid, le plugin et les requêtes externes.',
    readMoreAboutPluginManager: 'En savoir plus sur le gestionnaire de plugins',
    noPluginManagerConnected: 'Aucun gestionnaire de plugins connecté',
    noPluginManagerConnectedDescription: 'Le gestionnaire de plugins doit d\'abord envoyer une demande de connexion à votre organisation. Une fois la demande affichée ici, vous pouvez l\'accepter ou la refuser.',
    readMoreAboutConnectingPluginManager: 'En savoir plus sur la connexion d\'un gestionnaire de plugins',
    seeHowToEmitRequest: 'Voir comment émettre une demande',
    pluginManagerRequestTitle: 'Un gestionnaire de plugins a demandé à se connecter à votre organisation.',
    pluginManagerRequestDescription: 'Accepter cette demande le définira comme votre gestionnaire de plugins et activera l\'installation de plugins.',
    name: 'Nom',
    url: 'URL',
    requestedAt: 'Demandé à',
    accept: 'Accepter',
    deny: 'Refuser',
    offline: 'Hors ligne',
    connected: 'Connecté',
    readOnly: 'Lecture seule',
    readWrite: 'Lecture & Écriture',
    needHelp: 'Besoin d\'aide ?',
    connectPluginRegistry: 'Connecter un registre de plugins',
    registryName: 'Nom du registre',
    registryNameHint: 'Un nom unique pour ce registre',
    registryURL: 'URL du registre',
    registryURLHint: 'L\'URL où le registre est hébergé',
    rename: 'Renommer',
    disconnect: 'Déconnecter',
    createPluginTitle: 'Créer un nouveau plugin',
    createPluginDescription: 'Commencez par donner un nom à votre plugin. Ensuite, vous pourrez publier sa première version en référençant une image Docker depuis votre registre.',
    pluginNameHint: 'Le nom lisible par l\'homme pour votre plugin.',
    pluginRegistryHint: 'Le registre de plugins où enregistrer ce plugin.',
    renamePluginRegistry: 'Renommer le registre de plugins',
    renameRegistry: 'Renommer le registre',
    disconnectPluginRegistry: 'Déconnecter le registre de plugins',
    disconnectRegistry: 'Déconnecter le registre',
    disconnectRegistryWarning: 'La déconnexion de ce registre de plugins supprimera ses plugins de la vue dans cette organisation. Les plugins déjà installés resteront utilisables mais seront marqués comme orphelins (source manquante).',
    disconnectRegistryNote: 'Le registre lui-même et ses plugins ne sont pas supprimés et peuvent être reconnectés plus tard.',
    failedToCreatePlugin: 'Échec de la création du plugin',
    failedToCreatePluginRegistry: 'Échec de la connexion du registre de plugins',
    pluginCreatedSuccessfully: 'Plugin créé avec succès',
    failedToRenamePluginRegistry: 'Échec du renommage du registre de plugins',
    failedToDisconnectPluginRegistry: 'Échec de la déconnexion du registre de plugins',
    failedToUpdatePluginManager: 'Échec de la mise à jour du gestionnaire de plugins',
    pluginManagerUpdatedSuccessfully: 'Gestionnaire de plugins mis à jour avec succès',
    disconnectPluginManager: 'Déconnecter le gestionnaire de plugins',
    disconnectManager: 'Déconnecter le gestionnaire',
    disconnectPluginManagerWarning: 'La déconnexion de votre gestionnaire de plugins supprimera tous les plugins actuellement installés via celui-ci. Cette action est irréversible.',
    failedToDisconnectPluginManager: 'Échec de la déconnexion du gestionnaire de plugins',
    pluginManagerDisconnectedSuccessfully: 'Gestionnaire de plugins déconnecté avec succès',
    sharing: {
      title: 'Partage du plugin',
      visibilityLabel: 'Visibilité',
      local: 'Local',
      localHint: 'Seule cette organisation peut voir ce plugin',
      shared: 'Partagé',
      sharedHint: 'Partager ce plugin avec les organisations enfants',
      modeLabel: 'Mode de partage',
      modeAllChildren: 'Partager avec toutes les organisations enfants',
      modeInclude: 'Partager avec des organisations spécifiques',
      modeExclude: 'Partager avec toutes sauf...',
      inheritedFrom: 'Partagé depuis {org}',
      readOnly: 'Lecture seule (partagé depuis {org})',
      organizations: 'Organisations',
      selectOrganizations: 'Sélectionner des organisations...',
      save: 'Enregistrer',
      saveSuccess: 'Configuration de partage mise à jour',
    },
  },
  es: {
    widgetUnavailableTitle: 'Widget no disponible',
    widgetUnavailableText: 'Este plugin no está instalado o no está disponible actualmente.',
    pluginsInfoTitle: 'Para usar plugins, su organización debe tener al menos un registro de plugins y un gestor de plugins conectado.',
    pluginsInfoDescription: 'Añada un registro y acepte una solicitud de conexión de gestor de plugins para comenzar.',
    pluginName: 'Nombre de plugin',
    pluginSettings: 'Configuración de plugin',
    browsePlugins: 'Recorrer los plugins',
    navOrdering: 'Ordenación de la barra lateral',
    pluginRegistries: 'Registros de plugins',
    pluginRegistriesDescription: 'Configure registros externos donde Cycloid recupera los plugins disponibles. Cuando se agrega un registro, sus plugins pueden ser descubiertos y utilizados en toda su organización.',
    noPluginRegistriesAdded: 'No se han añadido registros de plugins',
    addPluginRegistryDescription: 'Añada un registro para empezar a usar plugins',
    readMoreAboutPluginRegistries: 'Leer más sobre registros de plugins',
    connectRegistry: 'Conectar registro',
    registry: 'Registro',
    access: 'Acceso',
    status: 'Estado',
    connectionErrorTitle: 'Error de conexión',
    connectionErrorDescription: 'No se puede conectar al registro. Compruebe la URL e inténtelo de nuevo.',
    pluginManager: 'Gestor de plugins',
    pluginManagerDescription: 'El gestor de plugins despliega plugins, orquesta sus contenedores y actúa como proxy de comunicación entre Cycloid, el plugin y las solicitudes externas.',
    readMoreAboutPluginManager: 'Leer más sobre el gestor de plugins',
    noPluginManagerConnected: 'No hay gestor de plugins conectado',
    noPluginManagerConnectedDescription: 'El gestor de plugins debe enviar primero una solicitud de conexión a su organización. Una vez que la solicitud aparezca aquí, puede aceptarla o rechazarla.',
    readMoreAboutConnectingPluginManager: 'Leer más sobre cómo conectar un gestor de plugins',
    seeHowToEmitRequest: 'Ver cómo emitir una solicitud',
    pluginManagerRequestTitle: 'Un gestor de plugins ha solicitado conectarse a su organización.',
    pluginManagerRequestDescription: 'Aceptar esta solicitud lo establecerá como su gestor de plugins y habilitará la instalación de plugins.',
    name: 'Nombre',
    url: 'URL',
    requestedAt: 'Solicitado a las',
    accept: 'Aceptar',
    deny: 'Denegar',
    offline: 'Desconectado',
    connected: 'Conectado',
    readOnly: 'Solo lectura',
    readWrite: 'Lectura y escritura',
    needHelp: '¿Necesita ayuda?',
    connectPluginRegistry: 'Conectar registro de plugins',
    registryName: 'Nombre del registro',
    registryNameHint: 'Un nombre único para este registro',
    registryURL: 'URL del registro',
    registryURLHint: 'La URL donde está alojado el registro',
    rename: 'Renombrar',
    disconnect: 'Desconectar',
    createPluginTitle: 'Crear un nuevo plugin',
    createPluginDescription: 'Comience dando un nombre a su plugin. Después, podrá publicar su primera versión haciendo referencia a una imagen Docker de su registro.',
    pluginNameHint: 'El nombre legible por humanos para su plugin.',
    pluginRegistryHint: 'El registro de plugins donde registrar este plugin.',
    renamePluginRegistry: 'Renombrar registro de plugins',
    renameRegistry: 'Renombrar registro',
    disconnectPluginRegistry: 'Desconectar registro de plugins',
    disconnectRegistry: 'Desconectar registro',
    disconnectRegistryWarning: 'Desconectar este registro de plugins eliminará sus plugins de la vista en esta organización. Los plugins que ya estén instalados seguirán siendo utilizables, pero se marcarán como huérfanos (fuente faltante).',
    disconnectRegistryNote: 'El propio registro y sus plugins no se eliminan y pueden volver a conectarse más tarde.',
    failedToCreatePlugin: 'Error al crear el plugin',
    failedToCreatePluginRegistry: 'Error al conectar el registro de plugins',
    pluginCreatedSuccessfully: 'Plugin creado con éxito',
    failedToRenamePluginRegistry: 'Error al renombrar el registro de plugins',
    failedToDisconnectPluginRegistry: 'Error al desconectar el registro de plugins',
    failedToUpdatePluginManager: 'Error al actualizar el gestor de plugins',
    pluginManagerUpdatedSuccessfully: 'Gestor de plugins actualizado con éxito',
    disconnectPluginManager: 'Desconectar gestor de plugins',
    disconnectManager: 'Desconectar gestor',
    disconnectPluginManagerWarning: 'Desconectar su gestor de plugins eliminará todos los plugins actualmente instalados a través de él. Esta acción no se puede deshacer.',
    failedToDisconnectPluginManager: 'Error al desconectar el gestor de plugins',
    pluginManagerDisconnectedSuccessfully: 'Gestor de plugins desconectado con éxito',
    sharing: {
      title: 'Compartir plugin',
      visibilityLabel: 'Visibilidad',
      local: 'Local',
      localHint: 'Solo esta organización puede ver este plugin',
      shared: 'Compartido',
      sharedHint: 'Compartir este plugin con organizaciones hijas',
      modeLabel: 'Modo de uso compartido',
      modeAllChildren: 'Compartir con todas las organizaciones hijas',
      modeInclude: 'Compartir con organizaciones específicas',
      modeExclude: 'Compartir con todas excepto...',
      inheritedFrom: 'Compartido desde {org}',
      readOnly: 'Solo lectura (compartido desde {org})',
      organizations: 'Organizaciones',
      selectOrganizations: 'Seleccionar organizaciones...',
      save: 'Guardar',
      saveSuccess: 'Configuración de uso compartido actualizada',
    },
  },
}
